import {TableContainer, CardBody, Card, Button, Grid, Select} from '@chakra-ui/react'
import {useNavigate} from "react-router-dom";
import {DataTable} from "../components/dataTable";
import {createColumnHelper} from "@tanstack/react-table";
import {useAppDataStore} from "../mobx/appDataStore";
import {useEffect, useMemo, useState} from "react";

const columnHelper = createColumnHelper();

const MailHistorial = () => {
  const appDataStore = useAppDataStore()
  const {socket} = appDataStore
  const rol = appDataStore.user?.rol?.name?.toLowerCase()
  const isAdmin = rol === 'admin'
  const [distribuidores, setDistribuidores] = useState([])
  const [distribuidorFilter, setDistribuidorFilter] = useState('')
  const [refreshDependencies, setRefreshDependencies] = useState(0)
  const navigate = useNavigate()

  useEffect(() => {
    document.title = 'Tienda Digital - Historial de correos'
  }, []);

  useEffect(() => {
    if (!isAdmin) return
    socket.emit('datasource', {model: 'User', records: 1000, currentPage: 1, searchAttributes: [], include: ['Rol']},
      (res) => setDistribuidores((res.data || []).filter(u => ['distribuidor', 'subadmin'].includes(u.Rol?.name))))
  }, []);

  useEffect(() => {
    setRefreshDependencies(Math.random())
  }, [distribuidorFilter]);

  // el include de MailLink siempre debe ir presente: el backend usa esta relación
  // para aplicar el scoping por distribuidorId cuando el usuario no es admin.
  const dataFetch = async (records, currentPage, order, search, filter, attributes) => {
    return new Promise(resolve => {
      const mailLinkInclude = {model: 'MailLink', attributes: ['perfil', 'producto', 'distribuidorId']}
      if (isAdmin && distribuidorFilter) mailLinkInclude.where = {distribuidorId: Number(distribuidorFilter)}
      const args = {model: 'MailHistorial', records, currentPage, order, search, filter, attributes, include: [mailLinkInclude]}
      socket.emit('datasource', args, resolve)
    })
  };

  const columns = useMemo(() => ([
    columnHelper.accessor('id', {cell: (info) => info.getValue(), header: "ID"}),
    columnHelper.accessor('email', {cell: (info) => info.getValue(), header: "Correo"}),
    columnHelper.accessor('MailLink.perfil', {cell: (info) => info.getValue(), header: "Perfil"}),
    columnHelper.accessor('MailLink.producto', {cell: (info) => info.getValue(), header: "Producto"}),
    columnHelper.accessor('provider', {cell: (info) => info.getValue(), header: "Proveedor"}),
    columnHelper.accessor('codigosVistos', {
      enableColumnFilter: false,
      cell: (info) => (info.getValue() || []).join(', '), header: "Códigos entregados"
    }),
    columnHelper.accessor('ip', {cell: (info) => info.getValue(), header: "IP"}),
    columnHelper.accessor('consultadoEn', {cell: (info) => Object.datetime(info.getValue()), header: "Fecha"}),
  ]), [])

  return (
    <Grid>
      <Card marginTop={5} marginLeft={5}>
        <CardBody>
          <Button colorScheme='blue' onClick={() => navigate('/admin/mailAccounts')} mb={5}>Cuentas vinculadas</Button>
          <Button marginLeft={2} colorScheme='blue' onClick={() => navigate('/admin/mailLinksNetflix')} mb={5}>Links Netflix</Button>
          <Button marginLeft={2} colorScheme='blue' onClick={() => navigate('/admin/mailLinks')} mb={5}>Links Disney/Crunchyroll</Button>
          <Button marginLeft={2} colorScheme='blue' onClick={() => navigate('/admin/chatgpt')} mb={5}>Links ChatGPT</Button>
          {isAdmin && (
            <Select
              display={'inline-block'} width={'250px'} marginLeft={2} mb={5} size={'sm'}
              value={distribuidorFilter} onChange={(e) => setDistribuidorFilter(e.target.value)}
            >
              <option value={''}>Todos los distribuidores</option>
              {distribuidores.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
            </Select>
          )}
          <TableContainer overflowX={'visible'} whiteSpace={'pre-wrap'} maxWidth={'1fr'}>
            <DataTable size={'sm'} columns={columns} dataFetch={dataFetch} refreshDependencies={refreshDependencies}/>
          </TableContainer>
        </CardBody>
      </Card>
    </Grid>
  )
}

export default MailHistorial
